import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'react-bootstrap'

const ThemeTable = ({ labels, children, isNumbered, isBordered, align }) => {
  return (
    <Table responsive className={`${isNumbered && 'numbered'} ${isBordered && 'bordered'} text-center font-semi text-nowrap`}>
      <thead align={align}>
        <tr>
          {labels.map((element, index) => {
            return <th key={index}>{element}</th>
          })}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </Table>
  )
}

ThemeTable.propTypes = {
  labels: PropTypes.array,
  children: PropTypes.any,
  isNumbered: PropTypes.bool,
  isBordered: PropTypes.bool,
  align: PropTypes.string
}

export default ThemeTable
